import { render, staticRenderFns } from "./NutritionalMonitoringChart.vue?vue&type=template&id=06a2d03c&scoped=true"
import script from "./NutritionalMonitoringChart.vue?vue&type=script&lang=js"
export * from "./NutritionalMonitoringChart.vue?vue&type=script&lang=js"
import style0 from "./NutritionalMonitoringChart.vue?vue&type=style&index=0&id=06a2d03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a2d03c",
  null
  
)

export default component.exports